import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-quantity-input',
  templateUrl: './quantity-input.component.html',
  styleUrls: ['./quantity-input.component.scss']
})
export class QuantityInputComponent implements OnInit, OnChanges {
  @Input() quantity: number;
  @Output() quantityChanged = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log('changes');
  }

  increase() {
    this.quantity += 1;
    this.quantityChanged.emit(this.quantity);
  }

  decrease() {
    if (this.quantity > 1) {
      this.quantity -= 1;
      this.quantityChanged.emit(this.quantity);
    }
  }
}
